import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import LoadingOverlay from '../components/LoadingOverlay'
import ToggleSimple from '../elements/ToggleSimple'
import globals from '../globals'

const ZeroDataRecharge = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isCancelled, setIsCancelled] = useState(false)
    const [isEnabled, setIsEnabled] = useState(props.serviceDetails.autoRechargeZeroData)
    const [hasError, setHasError] = useState(false)

    const handleUpdateStatus = (value) => {
        setIsLoading(true)
        setHasError(false)
        setIsEnabled(value)
        DataSource.postData('/api/postZeroDataAutoRecharge', { serviceId: props.serviceId, enabled: value }, response => {
            props.updateServiceDetails(false)
            setIsLoading(false)
        }, () => {
            setIsLoading(false)
            setHasError(true)
            setIsEnabled(!value)
        })
    }

    return (
        <div className='zero-data-auto-recharge module'>
            <Heading title='Zero data auto-recharge' />
            <ModuleWithLoader isLoaded className='p-4'>
                <div className='row mb-4'>
                    <div className='col-12 col-md-10 offset-md-1 text-center'>
                        <p className='m-0 lh'>Your ExeSIM mobile pre-paid service comes with auto-recharge every 30 days as default. This feature cannot be cancelled. But you can also opt-in to have your account auto-recharge whenever you run out of data during your usage cycle and your Data Bank is empty. For complete peace-of-mind, add Auto-recharge on Zero Data here.</p>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-lg-4 offset-lg-4 text-center'>
                        <div className='d-inline-block'>
                            <LoadingOverlay isLoading={isLoading}>
                                <ToggleSimple value={isEnabled} handleChange={handleUpdateStatus} />
                                <h4 className='bold text-uppercase m-0 my-2' dangerouslySetInnerHTML={{ __html: globals.noWidows('AUTO-RECHARGE ON ZERO DATA') }} />
                            </LoadingOverlay>
                            <div className='text-center mt-2'>
                                {hasError ? <div className='row-error mb-2'>Oops! Something went wrong. Please try again.</div> : ''}
                                <p className='m-0 font-small lh' dangerouslySetInnerHTML={{ __html: globals.noWidows('Enabling will ensure that your service will auto-recharge when you hit zero data (and your Data Bank is empty) mid cycle. ') }} />
                            </div>
                        </div>
                    </div>
                </div>
            </ModuleWithLoader>
        </div>
    )
}

ZeroDataRecharge.propTypes = {
    serviceId: PropTypes.number.isRequired,
    serviceDetails: PropTypes.object.isRequired,
    updateServiceDetails: PropTypes.func.isRequired
}

export default ZeroDataRecharge



// WEBPACK FOOTER //
// ./resources/js/modules/ZeroDataRecharge.js